"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var link_1 = __importDefault(require("next/link"));
var navigation_1 = require("next/navigation");
var react_1 = __importStar(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var Collapse = function (_a) {
    var parentHref = _a.parentHref, pathname = _a.pathname, href = _a.href, iconActive = _a.iconActive, icon = _a.icon, imageAlt = _a.imageAlt, onlyIconClick = _a.onlyIconClick, label = _a.label, items = _a.items, isOpen = _a.isOpen, _b = _a.target, target = _b === void 0 ? undefined : _b;
    return (react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.menuItemContainer, " menuItemContainer") },
        react_1.default.createElement("img", { className: "".concat(styles_module_scss_1.default.listItemIcon, " ").concat(parentHref ? styles_module_scss_1.default.accountMenuItem : ''), src: pathname === href || (parentHref && pathname.startsWith(parentHref))
                ? iconActive
                : icon, alt: imageAlt, onClick: function () {
                onlyIconClick && onlyIconClick();
            } }),
        react_1.default.createElement("span", { className: "".concat(styles_module_scss_1.default.itemLink) }, label),
        isOpen && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", null),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.collapseItems }, items === null || items === void 0 ? void 0 : items.map(function (i, idx) { return (react_1.default.createElement(link_1.default, { href: i.href, key: "profileMenu_".concat(i.label, "_").concat(idx), target: target },
                react_1.default.createElement("span", { className: pathname === i.href ? styles_module_scss_1.default.activeCollapseLink : '' }, i.label))); }))))));
};
var ProfileMenuListItem = function (_a) {
    var disabled = _a.disabled, onClick = _a.onClick, icon = _a.icon, iconActive = _a.iconActive, label = _a.label, href = _a.href, items = _a.items, collapse = _a.collapse, parentHref = _a.parentHref, alt = _a.alt, secondary = _a.secondary, langs = _a.langs, onlyIconClick = _a.onlyIconClick;
    var pathname = (0, navigation_1.usePathname)();
    var _b = (0, react_1.useState)(pathname === href || (parentHref && pathname.startsWith(parentHref))), isOpen = _b[0], setIsOpen = _b[1];
    var handleClick = (0, react_1.useCallback)(function (e) {
        e.stopPropagation();
        if (!disabled) {
            onClick ? onClick() : setIsOpen(!isOpen);
        }
    }, [disabled, isOpen, onClick]);
    var imageAlt = (0, react_1.useMemo)(function () { return (label ? label : alt ? alt : ''); }, [alt, label]);
    return (react_1.default.createElement("li", { className: "".concat(styles_module_scss_1.default.listItem, " ").concat(collapse ? styles_module_scss_1.default.listItemCollapse : '', " ").concat(isOpen && collapse ? styles_module_scss_1.default.isOpen : '', " ").concat(disabled ? styles_module_scss_1.default.grey : '', "  ").concat(pathname === href || (parentHref && pathname.startsWith(parentHref))
            ? styles_module_scss_1.default.active
            : '') },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.labels, onClick: handleClick },
            href && (react_1.default.createElement(link_1.default, { href: href },
                react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.menuItemContainer, " menuItemContainer ").concat(secondary ? styles_module_scss_1.default.secondary : '') },
                    react_1.default.createElement("img", { className: "".concat(styles_module_scss_1.default.listItemIcon, " ").concat(parentHref ? styles_module_scss_1.default.accountMenuItem : ''), src: pathname === href ||
                            (parentHref && pathname.startsWith(parentHref))
                            ? iconActive
                            : icon, alt: imageAlt, onClick: function () {
                            onlyIconClick && onlyIconClick();
                        } }),
                    react_1.default.createElement("span", { className: "".concat(styles_module_scss_1.default.itemLink) }, label)))),
            !href && !collapse && (react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.menuItemContainer, " menuItemContainer  ").concat(secondary ? styles_module_scss_1.default.secondary : '') },
                react_1.default.createElement("img", { className: styles_module_scss_1.default.listItemIcon, src: icon, alt: imageAlt, onClick: function () {
                        onlyIconClick && onlyIconClick();
                    } }),
                react_1.default.createElement("span", { className: "".concat(styles_module_scss_1.default.itemLink) }, label))),
            collapse && (react_1.default.createElement(Collapse, { parentHref: parentHref, pathname: pathname, href: href, iconActive: iconActive, icon: icon, imageAlt: imageAlt, onlyIconClick: onlyIconClick, label: label, items: items, isOpen: isOpen })),
            langs && langs)));
};
exports.default = ProfileMenuListItem;
